import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
// import "@/utils/rem";
import http from "@/utils/api";
Vue.prototype.$http = http;

Vue.config.productionTip = false

const vueInstance = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

export default vueInstance;